import { useIntl } from "react-intl";

import { PaidHeroTabPanelTemplate } from "./hero-tab-panel-template";

const SoftwareTabContent = () => {
    const intl = useIntl();

    const softwareHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.software.header",
            defaultMessage:
                "Jira is the #1 software development tool used by agile teams"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/fya3j34w81idu648i580m4mutc60guo0.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.software.heroImageAlt",
                defaultMessage: "Screen capture of a Jira board"
            })
        }
    };

    return <PaidHeroTabPanelTemplate {...softwareHeroProps} />;
};

export default SoftwareTabContent;
